/**
 * Maximum character limit for custom prompt in online reputation checks
 */
export const ONLINE_REPUTATION_CUSTOM_PROMPT_MAX_LENGTH = 3000;
